var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#D4BC87;stroke-width:0.8636;}\n\t.st1{fill:#D4BC87;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.1,10.1h2.4c0.1,0,0.1,0,0.1,0.1v6.6c0,0.1,0,0.1-0.1,0.1h-3.1c-0.1,0-0.1,0-0.1,0.1v2.9 c0,0.1-0.1,0.1-0.2,0.1l-4.4-3.1c0,0,0,0-0.1,0h-2c-0.1,0-0.1,0-0.1-0.1v-0.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18,14.2v0.4c0.2,0,0.4-0.2,0.4-0.4H18z M18,4.2h0.4c0-0.2-0.2-0.4-0.4-0.4V4.2z M11.3,14.2v-0.4 c-0.1,0-0.2,0-0.2,0.1L11.3,14.2z M6.3,17.3H5.9c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.3,0.1,0.4,0L6.3,17.3z M6.3,14.2h0.4 c0-0.2-0.2-0.4-0.4-0.4V14.2z M3,14.2H2.6c0,0.2,0.2,0.4,0.4,0.4V14.2z M3,4.2V3.8C2.8,3.8,2.6,4,2.6,4.2H3z M18.4,14.2v-10h-0.9v10 H18.4z M11.3,14.7H18v-0.9h-6.7V14.7z M6.6,17.7l5-3.1l-0.5-0.7l-5,3.1L6.6,17.7z M5.9,14.2v3.1h0.9v-3.1H5.9z M3,14.7h3.3v-0.9H3 V14.7z M2.6,4.2v10h0.9v-10H2.6z M18,3.8H3v0.9h15V3.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatGold);
export default __webpack_public_path__ + "static/media/chat-gold.3fd6c3152ff59ad478b6caec31eee317.svg";
export { ForwardRef as ReactComponent };